<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select v-model='theSelectProjectId' v-if="theUserProject==0" clearable size="small" @change="theSelectProjectChange" placeholder="请选择项目">
            <el-option
                v-for="item in getProjectList_data.data||[]"
                :key="item.projectId"
                :label="item.projectName"
                :value="item.projectId">
            </el-option>
        </el-select>
        <el-input
          v-model="getSysRuleIncomeDesList_data.yutName"
          placeholder="请输入收益规则描述名"
          clearable
          size='small'
          style="max-width:380px;"/>
        <el-button
          v-click.getSysRuleIncomeDesList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
      <el-col :span="6" >
        <el-button
          v-if="addSysRuleIncomeDes && theSelectProjectId"
          @click="toAddSysRuleIncomeDes"
          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >添加收益规则描述
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getSysRuleIncomeDesList'
      api='getSysRuleIncomeDesList'
      updateapi='updateSysRuleIncomeDes'
      :height="H-165" >
    </mytable> 

    <myform
      :viewobj='{
        addSysRuleIncomeDes:    [ "新增收益规则描述信息", "el-icon-circle-plus" ],
        updateSysRuleIncomeDes: [ "修改收益规则描述信息", "el-icon-edit-outline"],
        $succeed$: getSysRuleIncomeDesList
      }'
      @close='$form("addSysRuleIncomeDes","reset")'
      @opened="$form('addSysRuleIncomeDes','ifshow'),Myformdata.projectId=theSelectProjectId" >
      <hide slot='sridId' />
      <hide slot='projectId' />
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sridId: null,
      theSelectProjectId: "",
      theUserProject: "",
      tableColums_getSysRuleIncomeDesList: {
        $selection: false,

        sridDes: '规则描述',
        sridOrder: '排序',
        createtime: '创建时间',

        $operation: [
          '操作', 200,
          this.updateSysRuleIncomeDes &&`@text: 编辑#success
           @click: $form("updateSysRuleIncomeDes",$row)
          `,
          this.deleteSysRuleIncomeDes && `@text: 删除#danger
           @click: _confirm('确定要删除该收益规则描述吗?')
                   .trigger('deleteSysRuleIncomeDes',{sridId:$row.sridId})
                   .trigger('getSysRuleIncomeDesList')
          `,
        ],

      },

    };
  },

  watch: {
    
  },

  methods: {
    toAddSysRuleIncomeDes(){
      this.$form('addSysRuleIncomeDes');
    },
    theSelectProjectChange(e){
      this.theSelectProjectId=e;
      this.getSysRuleIncomeDesList({projectId:this.theSelectProjectId});
    },
  },

  created() {
    this.theUserProject=A.local('$projectId');
    if(this.theUserProject!=0){
      this.theSelectProjectId=this.theUserProject;
    }
    this.getSysRuleIncomeDesList({projectId:this.theSelectProjectId});
    this.getProjectList({ pageSize: 0 });
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/rule/IncomeRuleDesManage.vue